var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('confirm-action-dialog', {
    attrs: {
      "title": _vm.title,
      "isDialogActive": _vm.dialog,
      "hideLeft": true,
      "width": '1200px',
      "height": '800px',
      "supressKeyboardConfirm": true
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.dialog = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.dialog = $event;
      },
      "rightClick": function rightClick() {
        return _vm.sendMail();
      }
    }
  }, [_c('v-card-text', [_c('preselect-template-card', {
    ref: "templateCard",
    staticClass: "mt-1",
    attrs: {
      "templateKey": _vm.templateKey,
      "language": _vm.partner.language,
      "partnerId": _vm.partner.id,
      "from": [_vm.partner],
      "context": _vm.context,
      "to": _vm.entity.seller ? [_vm.entity.seller.email] : [],
      "refs": _vm.refs
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }